import {
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormGroup,
    Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';
import { ACCESS, useAuth, checkAccess } from './RefreshMachineStatus';
const MROAccessGroupInput = ({ client, value, onValueChange, initialValue, ...rest }) => {
    const [loading, setLoading] = useState(true);
    const [options, setOptions] = useState([]);
    const [selectedValues, setSelectedValues] = useState(value || initialValue || []);

    const dataProvider = useDataProvider();
    const { loaded: authLoaded, user, can } = useAuth();
    const loginHasMROAccess = can(ACCESS.MRO);

    useEffect(() => {
        if (!authLoaded) return;

        const run = async () => {
            if (user) {
                await getEmployeeTypes();
            }
            setLoading(false);

            if (!value && initialValue?.length) {
                setSelectedValues(initialValue);
                onValueChange && onValueChange(initialValue);
            } else {
                setSelectedValues(value);
                onValueChange && onValueChange(value);
            }
        };

        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authLoaded, user, client]);

    const getEmployeeTypes = async () => {
        try {
            const res = await dataProvider.getList("employeeTypes", {
                pagination: { page: 1, perPage: 10000 },
                sort: { field: "name", order: "ASC" },
                filter: { client },
            });

            const fetchedOptions = res.data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setOptions(fetchedOptions);
        } catch (err) {
            console.log(err);
        }
    };

    const handleValueChange = (updatedValues) => {
        const finalValues = updatedValues.length === 0 ? initialValue : updatedValues;
        setSelectedValues(finalValues);
        onValueChange && onValueChange(finalValues);
    };

    return (
        <>
            <Typography gutterBottom variant="h6">
                MRO Access
            </Typography>
            <Typography gutterBottom variant="body2">
                Select to enable access to employee group
            </Typography>
            {loading ? (
                <CircularProgress size={20} />
            ) : (
                <FormControl component="fieldset">
                    <FormGroup>
                        {options.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                label={option.label}
                                control={
                                    <Checkbox
                                        name="mroAccessGroup"
                                        value={option.value}
                                        checked={selectedValues.includes(option.value)}
                                        onChange={(e) => {
                                            const { value: checkboxValue, checked } = e.target;
                                            const updatedValues = checked
                                                ? [...selectedValues, checkboxValue]
                                                : selectedValues.filter((v) => v !== checkboxValue);

                                            handleValueChange(updatedValues);
                                        }}
                                        disabled={!loginHasMROAccess}
                                        {...rest}
                                    />
                                }
                            />
                        ))}
                    </FormGroup>
                </FormControl>
            )}
        </>
    );
};

export default MROAccessGroupInput;
